import React from 'react';
import { Row, BodyText, View, InlineLink } from 'modules/styled';
import { useSelector } from 'react-redux';
import CommunityList from 'modules/community/communityList.component';
import { ScrollView } from 'react-native';
import Spinner from 'modules/ui/mobile/CustomSpinner.component';

export default () => {
  const loaded = useSelector((state) => state.community.list?.length > 0);
  if (!loaded) return <Spinner />;
  return (
    <ScrollView>
      <View sx={{ flex: 1, bg: 'white' }}>
        <CommunityList />
        <Row sx={{ mx: 4, mt: 6, mb: 12, alignItems: 'baseline' }}>
          <InlineLink inline={1} external to="mailto:info@relevant.community">
            <BodyText sx={{ color: 'blue' }}>Get in touch </BodyText>
          </InlineLink>
          <BodyText>if you'd like to start your own community</BodyText>
        </Row>
      </View>
    </ScrollView>
  );
};
